// removed by extract-text-webpack-plugin
module.exports = {"circle":"circle---3nsPV","square":"square---10F3N"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/Avatar/style.styl
// module id = A/zB
// module chunks = 88